import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import lessRequire from '../../../config/less-require-resolver';
const images = require.context('./../../../../cabinets/apps/rocket/assets/img/ranks', true);

lessRequire('modules/ranks/components/progress-bar.less');

const propTypes = {
	data: PropTypes.object,
	intl: PropTypes.func,
	currentRank: PropTypes.object,
	toggleRankPopup: PropTypes.func,
	points_per_month: PropTypes.number,
	pointsLeft: PropTypes.number,
	ranksList: PropTypes.object
};

const ProgressBar = props => {
	const { intl } = props;
	const {totalPercent, currentPercent} = getProgressbarState(props);
	const currentRankId = props.currentRank.id;
	return (
		<div className="ranks-progress__container">
			<div className="ranks-progress__bar">
				<div className="ranks-progress__bar-progress" style={{width: totalPercent}}>
				</div>
				<div className="ranks-progress__bar-current-progress" style={{width: `${currentPercent}%`}}>
					<div className={cn({
						'poinst-left': true,
						'shifted-right': currentPercent < 10,
						'hidden': currentRankId === 5,
						'shifted-left': currentPercent > 90
					})}>
						{intl('Осталось')} {Math.round(props.pointsLeft)}
					</div>
				</div>
			</div>
			<div className="rokky-bar font-museo-sans-regular">
				<div className="a1">
					<img src={images('./0.png')}/>
					<span>{intl('Начальный от')} 1</span>
				</div>
				<div className="a2">
					<img src={images('./1.png')}/>
					<span>Bronze 2 500</span>
				</div>
				<div className="a3">
					<img src={images('./2.png')} className={cn({inactive: currentRankId < 1})}/>
					<span>Silver 7 500</span>
				</div>
				<div className="a4">
					<img src={images('./3.png')} className={cn({inactive: currentRankId < 2})}/>
					<span>Gold 25 000</span>
				</div>
				<div className="a5">
					<img src={images('./4.png')} className={cn({inactive: currentRankId < 3})}/>
					<span>Diamond 50 000</span>
				</div>
				<div className="a6">
					<img src={images('./5.png')} className={cn({inactive: currentRankId < 4})}/>
					<span>Black Member 500 000</span></div>
			</div>
		</div>
	);
};

const getProgressbarState = ({points_per_month}) => {
	if (points_per_month < 2500)
		return {totalPercent: '20%', currentPercent: 20*points_per_month/2500};
	if (points_per_month < 7500)
		return {totalPercent: '40%', currentPercent: 20 + 20*(points_per_month - 2500)/(7500 - 2500)};
	if (points_per_month < 25000)
		return {totalPercent: '60%', currentPercent: 40 + 20*(points_per_month - 7500)/(25000 - 7500)};
	if (points_per_month < 50000)
		return {totalPercent: '80%', currentPercent: 60 + 20*(points_per_month - 25000)/(50000 - 25000)};
	if (points_per_month < 500000)
		return {totalPercent: '100%', currentPercent: 80 + 20*(points_per_month - 50000)/(500000 - 50000)};
	return {totalPercent: '100%', currentPercent: 100};
};

ProgressBar.propTypes = propTypes;

export default ProgressBar;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/ranks/components/progress-bar.js